import { useCallback, useMemo } from "react";
import { useGridFilter } from "ag-grid-react";

// model shape: { flagged: boolean, approved: boolean, rejected: boolean, completed: boolean } | null
export default function CustomApprovalFilter({ model, onModelChange, hasApprovals }) {
  const m = useMemo(
    () => ({
      flagged: Boolean(model?.flagged),
      waiting: Boolean(model?.waiting),
      approved: Boolean(model?.approved),
      rejected: Boolean(model?.rejected),
      completed: Boolean(model?.completed),
    }),
    [model]
  );

  const OPTIONS = useMemo(
    () => {
      const ops = [
        { key: "flagged", label: "Flagged" },
      ]
      if (hasApprovals) {
        ops.push(...[
          { key: "waiting", label: "Waiting" },
          { key: "approved", label: "Approved" },
          { key: "rejected", label: "Rejected" },
          { key: "completed", label: "Paid" },
        ])
      }
      return ops;
    },
    [hasApprovals]
  );

  const isAnySelected = m.flagged || m.waiting || m.approved || m.rejected || m.completed;

  const doesFilterPass = useCallback(
    ({ node }) => {
      // If nothing selected, don't filter anything out
      if (!isAnySelected) return true;

      const data = node?.data || {};
      const flag = Boolean(data.flag);
      const status = String(data?.approval?.status || "").toLowerCase();

      // OR logic: if any checked condition matches, row passes
      if (m.flagged && flag) return true;
      if (m.waiting && status === "") return true;
      if (m.approved && status === "approved") return true;
      if (m.rejected && status === "rejected") return true;
      if (m.completed && status === "completed") return true;

      return false;
    },
    [isAnySelected, m.flagged, m.waiting, m.approved, m.rejected, m.completed]
  );

  useGridFilter({ doesFilterPass });

  const setChecked = (key, checked) => {
    const next = {
      ...m,
      [key]: checked,
    };

    // store null when nothing is selected (keeps AG Grid "no filter" semantics)
    const any = next.flagged || next.waiting || next.approved || next.rejected || next.completed;
    onModelChange(any ? next : null);
  };

  return (
    <div style={{ padding: 8, minWidth: 160, display: 'flex', flexDirection: 'column', gap: '6px', fontFamily: 'ProximaSoft-Regular, "Open Sans", sans-serif' }}>
      {OPTIONS.map(({ key, label }) => (
        <label key={key} style={{ display: "flex", cursor: 'pointer', gap: 8, alignItems: "center", marginBottom: 0 }}>
          <input
            style={{ cursor: 'pointer' }}
            type="checkbox"
            checked={m[key]}
            onChange={(e) => setChecked(key, e.target.checked)}
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  );
}
